import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import classnames from 'classnames';
import RadioButton from './radio-button';
import Icon from '../../../../libraries/utils/components/icon.tsx';

class RadioButtonPanel extends Component {
  static displayName = 'RadioButtonPanel';

  static propTypes = {
    children: PropTypes.any,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    updateExpend: PropTypes.func,
    isExpend: PropTypes.bool,
    className: PropTypes.string,
    withExpand: PropTypes.bool
  };

  static defaultProps = {
    withExpand: true
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.isExpend
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isExpend !== this.state.isExpend) {
      this.setState({ expanded: nextProps.isExpend });
    }
  }

  @autobind
  toggle() {
    this.setState({ expanded: !this.state.expanded });
    this.props.updateExpend(!this.state.expanded, this.props.value);
  }

  @autobind
  radioClickHandler(value, event) {
    event.stopPropagation();
    this.setState({ expanded: true });
    this.props.updateExpend(true, this.props.value);
    this.props.onChange(value);
  }

  render() {
    const { withExpand, name, title, value, checked } = this.props;
    let panelClassName = classnames('checkbox-panel', { expanded: this.state.expanded });
    let panelBodyClassName = classnames('panel-body', {
      [this.props.className]: this.props.className
    });
    return (
      <div className={panelClassName}>
        <div className="panel-header" onClick={this.toggle}>
          <RadioButton
            checkboxClick={this.radioClickHandler}
            name={name}
            text={title}
            value={value}
            checked={checked}
          />
          {withExpand && <Icon name="caret-down" className="dropdown-arrow" />}
        </div>
        <div className={panelBodyClassName}>{this.props.children}</div>
      </div>
    );
  }
}

export default RadioButtonPanel;
